import React from "react"
import NavBar from "../../components/navigation/NavBar"
import Footer from "../../components/footer/Footer"
import MbpHead from "../../components/head/MbpHead"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import nextI18NextConfig from "../../next-i18next.config"
import PropTypes from "prop-types"
import {getStrapiPage} from "../../strapi/api/getPage"
import fetchPosts from "../../fetch/FetchPosts"
import BikeSuggest from "../../components/reusable/BikeSuggest"
import {useTranslation} from "next-i18next"
import {getPageData} from "../../pageData"
import getGenericLandingPages from "../../strapi/api/getGenericLandingPages"
import MarkdownRenderer from "../../components/reusable/MarkDownRender"
import {contentTypes} from "../../strapi/contentTypes"
import {getAllBikes} from "../../postgres/selectHelpers/selectQuery"

type Props = {
  localisedSlugs: any[],
  isCollection: boolean,
  posts: any[],
	strapiPageContent: any
}

const Collection: React.FC<Props> = ({strapiPageContent, localisedSlugs, posts, isCollection}) => {
	const {
		seoTitle,
		seoDescription,
		content
	} = strapiPageContent?.attributes ? strapiPageContent.attributes : null
	const {t} = useTranslation()

	return (<>
		<MbpHead>
			<title>{`${seoTitle || ""} | MyBikePlan`}</title>
			<meta name="description"
				content={seoDescription}/>
			<meta property="og:title"
				content={seoTitle || ""}
				key="title"/>
			<meta property="og:description"
				content={seoDescription}
				key="description"/>
		</MbpHead>
		<NavBar />
		<section className={"collection-page"}>
			<MarkdownRenderer markdownContent={content}/>
			<BikeSuggest t={t}/>
		</section>
		<Footer/>
	</>
	)
}

Collection.propTypes = {
	posts: PropTypes.any.isRequired
}

export async function getStaticPaths({locales}) {
// Call Contentful API endpoint to get pages
	let paths = []
	for (const locale of locales) {
		// eslint-disable-next-line no-await-in-loop
		const pages = await getGenericLandingPages(locale)
		// @ts-ignore
		paths = paths.concat(pages.map(page => {
			return {
				params: {
					// @ts-ignore
					slug: page.fields?.slug
				}, locale: "de"
			}
		}))
	}

	return {paths, fallback: "blocking"}
}

export async function getStaticProps({locale, params}) {
	const strapiPageContent = await getStrapiPage(locale, params.slug, contentTypes.genericLandingPage)

	return {
		props: {
			// Fetch collection page list for use in Mega Menu
			...(await getPageData(locale)),
			strapiPageContent,
			...(await serverSideTranslations(locale, ["common", "URL", "search", "insurance", "filters", "PDPTiles", "productDescrPage"], nextI18NextConfig))
		}
	}
}

export default Collection
